(function() {
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function getSantiagoNow() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Santiago' }));
  }
  var DAYS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var CUTOFF = 13; // hora de corte de despacho
  // Día hábil de despacho: Lunes(1) a Sábado(6). Domingo(0) cerrado.
  function isWorkingDay(d) { return d >= 1 && d <= 6; }
  function updateShipping() {
    var now = getSantiagoNow();
    var h = now.getHours(), m = now.getMinutes(), s = now.getSeconds();
    var dow = now.getDay();
    var dot = document.getElementById('cyq-dot');
    var text = document.getElementById('cyq-urgency-text');
    var countdown = document.getElementById('cyq-countdown');
    var cdWrap = document.getElementById('cyq-countdown-wrap');
    var badge = document.getElementById('cyq-dispatch-badge');
    if (!dot || !text) return;
    // Caso 1: hoy es hábil y antes de las 13:00 -> despachamos/recibe HOY
    if (isWorkingDay(dow) && h < CUTOFF) {
      var secsLeft = (CUTOFF - 1 - h) * 3600 + (59 - m) * 60 + (59 - s);
      var lh = Math.floor(secsLeft / 3600);
      var lm = Math.floor((secsLeft % 3600) / 60);
      var ls = secsLeft % 60;
      dot.style.background = '#1D9E75';
      dot.classList.add('cyq-dot-pulse');
      text.textContent = 'Recibe HOY — compra antes de las 13:00';
      if (countdown) {
        countdown.textContent = 'Quedan ' + lh + 'h ' + pad(lm) + 'min ' + pad(ls) + 's';
        countdown.style.display = 'inline-block';
      }
      if (cdWrap) cdWrap.style.display = '';
      if (badge) badge.textContent = '🚚 Te lo enviamos hoy';
      return;
    }
    // Caso 2: pasó el corte o es domingo -> próximo día hábil (salta domingo)
    dot.style.background = '#0F6E56';
    dot.classList.remove('cyq-dot-pulse');
    if (cdWrap) cdWrap.style.display = 'none';
    var next = new Date(now.getTime());
    next.setDate(next.getDate() + 1); // como mínimo, mañana
    while (!isWorkingDay(next.getDay())) {
      next.setDate(next.getDate() + 1);
    }
    var manana = new Date(now.getTime());
    manana.setDate(manana.getDate() + 1);
    var esManana = (next.toDateString() === manana.toDateString());
    if (esManana) {
      text.textContent = 'Compra hoy y recibe mañana';
      if (badge) badge.textContent = '🚚 Te lo enviamos mañana';
    } else {
      text.textContent = 'Compra hoy y recibe el ' + DAYS[next.getDay()];
      if (badge) badge.textContent = '🚚 Te lo enviamos el ' + DAYS[next.getDay()];
    }
  }
  updateShipping();
  setInterval(updateShipping, 1000);
})();